export const featuredPortfolio = [
    {
      id: 1,
      title: "Voice-driven AI portfolio",
      img:
        "assets/web1.png",
        link:"https://www.loom.com/share/0fb30156346042d586bcb3899d65cb8f"
    },
    {
      id: 2,
      title: "COVID-19 analysis with probabilistic graphical models",
      img:
        "assets/covid.jpg",
        link:"https://github.com/varshil1/Covid_19_Analysis_Using_PGM"
    },
    {
      id: 3,
      title: "Personal finance management",
      img:
        "assets/finance.png",
      link:"https://github.com/varshil1/Financial_Management-main"
      },
    {
      id: 4,
      title: "Movie recommendation system",
      img:
        "assets/movie.jpg",
      link:"https://github.com/varshil1/CSE523-Machine-Learning-SSSR"
    },
    { id: 5,
      title: "Reinforcement learning for paper trading",
      img:"assets/alpaca.png",
      link:"https://github.com/varshil1/Algorithmic-paper-trading-using-Deep-Reinforcement-Learning"
    },
    {
      id: 6,
      title: "Computer vision for social distancing",
      img:
        "assets/socio.jpg",
      link:"https://github.com/varshil1/Social-Distancing-using-OpenCV"
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Voice-driven AI portfolio",
      img:
        "assets/web1.png",
        link:"https://www.loom.com/share/0fb30156346042d586bcb3899d65cb8f"
      },
    {
      id: 2,
      title: "IDENTI-TEE shopping website",
      img: "assets/identite.png",
      link:""
    },
    {
      id: 3,
      title: "Smart finance management system",
      img: "assets/fin.jpg",
      link:"https://github.com/varshil1/Financial_Management-main"
    },{
      id: 4,
      title: "Responsive developer club website",
      img: "assets/pclub.JPG",
      link:"https://github.com/varshil1/Animated-Responsive-website"
    },{
      id: 5,
      title: "Pedalsup Innovations",
      img: "assets/pedalsup.PNG",
      link:"https://pedalsup.com/"
    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Chatting Social Media App",
      img:
        "assets/whatsapp.jpg",
      link:"https://github.com/varshil1/AutoSend_Whatsapp_messages"
    },
    
    {
      id: 2,
      title: "Find best Mentor",
      img:
        "assets/mentor.png",
      link:""
      },
    
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "COVID-19 analysis with probabilistic graphical models",
      img:
        "assets/covid.jpg",
        link:"https://github.com/varshil1/Covid_19_Analysis_Using_PGM"
       },
    {
      id: 2,
      title: "Movie recommendation system",
      img:
        "assets/movie.jpg",
      link:"https://github.com/varshil1/CSE523-Machine-Learning-SSSR"
      },
    {
      id: 3,
      title: "Reinforcement learning for paper trading",
      img:"assets/alpaca.png",
      link:"https://github.com/varshil1/Algorithmic-paper-trading-using-Deep-Reinforcement-Learning"
    },
    {
      id: 4,
      title: "Computer vision for social distancing",
      img:
        "assets/socio.jpg",
        link:"https://github.com/varshil1/Social-Distancing-using-OpenCV"
      },
    {
      id: 5,
      title: "Whatsapp Chatbot using NLP",
      img:
        "assets/wchat.png",
        link:"https://github.com/varshil1/ConnectFor-Chatbot-"
    },
    
  ];
  
  export const contentPortfolio = [
    {
      id: 1,
      title: "Autosend Messages from whatsapp using selenium",
      img:
        "assets/wchat.png",
        link:"https://github.com/varshil1/AutoSend_Whatsapp_messages"
    },
   
  ];
  
